import { render, staticRenderFns } from "./OpenProductions.vue?vue&type=template&id=4b9c1562&scoped=true&"
import script from "./OpenProductions.vue?vue&type=script&lang=js&"
export * from "./OpenProductions.vue?vue&type=script&lang=js&"
import style0 from "./OpenProductions.vue?vue&type=style&index=0&id=4b9c1562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c1562",
  null
  
)

export default component.exports